<template>
    <div>
        <div
            v-if="isLoading"
            class="d-flex justify-content-center align-items-center py-5"
        >
            <b-spinner variant="primary" label="Yukleniyor..." />
        </div>
        <div v-else-if="!bioKeyId" class="text-center py-5">
            <b-alert
                show
                variant="danger"
            >
                Bu link tipi bulunamadı.
            </b-alert>
        </div>  


        <div v-else :key="`bio-content-${renderKey}`">

            <b-row>
                <b-col cols="6" v-for="platform in platformOptions" :key="`${platform.id}-${renderKey}`" v-if="platformOptions.length > 0">
                    <basic-summary :type="bioKeyId" :vestingHide="true" :platform="platform" @add-trigger="addTrigger"/>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="6">
                    <echart-stacked-area-metric
                        metric="cart"
                        :link_type="bioKeyId"
                    />
                </b-col>
                <b-col cols="6">
                    <echart-stacked-area-metric
                        metric="order"
                        :link_type="bioKeyId"
                    />
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <echart-stacked-area-metric
                        metric="event"
                        :link_type="bioKeyId"
                    />
                </b-col>
            </b-row>

            <!-- <apex-line-area-chart/>-->
            <!-- <echart-stacked-area
                :link_type="3"
            /> -->
            
            <b-tabs
                v-if="influencer"
                pills
                >
                <b-tab>
                    <template #title>
                    <feather-icon
                        icon="InfoIcon"
                        size="16"
                        class="mr-0 mr-sm-50"
                    />
                    <span class="d-none d-sm-inline">Geçmiş Paylaşımlar</span>
                    </template>
                    <b-alert
                        v-if="!influencer"
                        show
                        variant="danger"
                    >
                        Fenomen bilgisi bulunamadı.
                    </b-alert>
                    <campaign-list :key="`campaign-list-${renderKey}`" :tableColumns="tableColumns" :params="params" :addBtnShow="addBtnControl" ref="linkList"></campaign-list>
                </b-tab>
            </b-tabs>

        </div>
    </div>
</template>


<script>
    import { BRow,BLink, BAlert,BBadge,BCardTitle, BCol, BCard, BCardHeader, BCardBody, BTab, BTabs,BButton, BSpinner } from 'bootstrap-vue';
    import BasicSummary from '@/components/BasicSummary.vue';
    import CampaignList from '../campaign/Links.vue';
    import ApexLineAreaChart from '@/components/charts-components/ApexLineAreaChart.vue';
    import EchartStackedArea from '@/components/charts-components/EchartStackedArea.vue';
    import EchartStackedAreaMetric from '@/components/charts-components/EchartStackedAreaMetric.vue';
    export default {
        components: {
            BTab, 
            BTabs,
            BRow,
            BCol,
            BLink,
            BCard,
            BCardHeader,
            BCardBody,
            BAlert,
            BBadge,
            BButton,
            BCardTitle,
            BSpinner,

            BasicSummary,
            CampaignList,
            ApexLineAreaChart,
            EchartStackedArea,
            EchartStackedAreaMetric
        },
        data() {
            return {
                isLoading : true,
                influencer: {},
                isActiveTab: {},
                tableColumns : [
                    { key: 'id', sortable: true },
                    { key: 'campaign_name', label: 'Paylaşım', sortable: true },
                    { key: 'platform', label: 'Platform', sortable: true },
                    { key: 'created_date', label: 'Ekleme Tarihi', sortable: true },
                    { key: 'start_date',label:'Başlama Tarihi', sortable: false },
                    { key: 'end_date',label:'Bitiş Tarihi', sortable: false },
                    { key: 'event_count',label:'Ziyaret', sortable: false },
                    { key: 'cart_count',label:'Sepete Ekleme', sortable: false },
                    { key: 'order_count',label:'Sipariş Adedi', sortable: false },
                    { key: 'total_amount',label:'Sipariş Tutarı', sortable: false },
                    { key: 'status', label: 'Durum'},
                    { key: 'actions', label: 'Detay'},
                ],
                bioKeyId: null,
                params:{
                    filter:{
                        type: null
                    },
                    source: this.$route.name,
                },     
                platformOptions:[],
                renderKey: 0,
            }
        },
        computed: {
            addBtnControl() {
                return this.$store.state.user.userData.permissions?.includes('firma_paylasimi.bio_ekleyebilir_duzenleyebilir');
            }
        }, 
        methods: {
            addTrigger(id) {
                this.$refs.linkList.platform = id;
                setTimeout(() => {
                    this.$refs.linkList.isAddNewLinkSidebarActive = true;
                }, 100);
            },
            async fetchPlatforms() {
                try {
                const response = await this.$http.get('/platforms', { 
                    params: { 
                        filter:{
                            status: 1
                        },
                        source: 'bio-detail'
                    } 
                });
                    this.platformOptions = response.data.data
                } catch (error) {
                    console.error('Platformlar yüklenirken bir hata oluştu:', error);
                }
            },
            async fethhLinkType() {
                try {
                    const response = await this.$http.get('/link/type', { 
                        params: { 
                            key: this.$route.params.key
                        } 
                    });
                    const typeRow = response?.data?.data?.[0] || null;
                    this.bioKeyId = typeRow ? typeRow.id : null;
                    this.params.filter.type = typeRow ? typeRow.id : null;
                } catch (error) {
                    this.bioKeyId = null;
                    this.params.filter.type = null;
                    console.error('Link tipleri yüklenirken bir hata oluştu:', error);
                }
            },
            async initializeBioPage() {
                this.isLoading = true;
                this.bioKeyId = null;
                this.params.filter.type = null;
                this.params.source = this.$route.name;

                await Promise.all([
                    this.fetchPlatforms(),
                    this.fethhLinkType(),
                ]);

                this.renderKey += 1;
                this.isLoading = false;
            },
        },
        watch: {
            '$route.params.key': {
                handler() {
                    this.initializeBioPage();
                },
            },
        },
        mounted () {
            this.initializeBioPage();
        },
    }
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
</style>
<style lang="scss" scoped>

</style>